module.exports = __webpack_public_path__ + "static/media/icon_balloons.286c50be.svg";